<template>
  <div
    class="box"
    @click="boxUpdateConfig({ item: 'advanced', key: 'view_mode', value: 'click' });sidebarChangePanel('themes')">
    <div class="box-image">
      <img src="../../../../assets/img/box-click.svg" alt="">
    </div>
    <div class="pull-right">
      <div class="box-title">{{ $t('edit.sidebar.on_click') }}</div>
      <span class="box-text">{{ $t('edit.sidebar.on_click_some_button') }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: mapActions([
    'boxUpdateConfig',
    'sidebarChangePanel',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Click.vue?b805f170
 **/